import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { OmsService } from 'app/services/oms.service';
import { OrdersService } from 'app/services/orders.service';
import { UsersService } from 'app/services/users.service';
import { Observable } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'app-sticker-scan-out-history',
	templateUrl: './sticker-scan-out-history.component.html',
	styleUrls: ['./sticker-scan-out-history.component.scss'],
})
export class StickerScanOutHistoryComponent implements OnInit {

	showHistory = false;
	batchHistory: any = false;
	batchHistoryFiltered: any = false;
	historymatches: any = [];
	historySearchRef = new UntypedFormControl(''); //modal
	historyLoading: any = false;
	dataSource = new MatTableDataSource<any>;
	BOLhtml: any = false;
	@ViewChild('reprintModal') reprintModalRef: ElementRef;
	private sort: MatSort;

	fromdateCtrl = new UntypedFormControl('');
	todateCtrl = new UntypedFormControl('');
	todate = new Date();
	fromdate = new Date();
	orderTypes = [
		{ view : 'Packed', value: 25 },
		{ view : 'Staged', value: 26 }
	];

	shipperTypeFilter = new UntypedFormControl('all');
	shipvias: any = false;
	config: any = false;
	user: any = false;
	batchViewing: any = false

	constructor(private sanitizer: DomSanitizer, private omsService:OmsService, private usersService:UsersService, private modalService: NgbModal, private _changeDetectorRef: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private ordersService: OrdersService) { }

	ngOnInit(): void {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.globalSearchService.user.subscribe(u => {
				this.user = u;
			})
		});
		
		this.ordersService.getStickerShipvias().subscribe((res: any) => {
			if(res.data){
				this.shipvias = res.data ;
			}
		})
		
		this.setDates();
		this.shipperTypeFilter.valueChanges.subscribe(() => { this.filterOrders(); })
		this.fromdateCtrl.valueChanges.subscribe(() => { this.filterOrders(); })
		this.todateCtrl.valueChanges.subscribe(() => { this.filterOrders(); })
		this.getHistory();
	}

	setDates(){
		const today = new Date();
		const priorDate = new Date(today.getFullYear(), today.getMonth(), 1);
		this.fromdate = priorDate;
		this.fromdate.setMonth(this.fromdate.getMonth() - 3);
		this.fromdateCtrl.setValue(this.fromdate)
		this.todateCtrl.setValue(this.todate)
	}

	getHistory() {
		if (this.historyLoading) {
			this.historyLoading = false;
		}

		this.historyLoading = this.ordersService.getStickerBatchHistory().subscribe((res: any) => {
			this.historyLoading = false;
			this.batchHistory = res;
			this.batchHistoryFiltered = res;
			this.setPagination(this.batchHistoryFiltered)
		});
	}


	filterOrders(){
		const fromdate = this.fromdateCtrl.value;
		const todate = this.todateCtrl.value;
		const shipper_id = this.shipperTypeFilter.value;
		this.batchHistoryFiltered = this.batchHistory;
	
		if(fromdate && todate){
			const from = new Date(fromdate);
			const to = new Date(todate);
			
			from.setHours(0);
			from.setMinutes(0);
			from.setSeconds(0);
			to.setHours(23);
			to.setMinutes(59);
			to.setSeconds(59);

			this.batchHistoryFiltered = this.batchHistoryFiltered.filter((batch) => {
				const shippeddate = new Date(batch['shippedtime']);
				if(from <= shippeddate && to >= shippeddate){
					return batch;
				}
			})
		}

		if(shipper_id && shipper_id !== 'all'){
			this.batchHistoryFiltered = this.batchHistoryFiltered.filter((batch) => {
				return batch.shipper_id === shipper_id;
			})
		}

		const search = this.historySearchRef.value.toUpperCase();
		if (search.length) {
			this.historymatches = [];
			this.batchHistoryFiltered = this.batchHistoryFiltered.filter((batch: any) => {
				let hasmatch = false;
				(batch.orders).forEach((order) => {
					const formatted = Object.values(order).join('++').toUpperCase();
					if (formatted.includes(search)) {
						this.historymatches.push(order.orderno);
						hasmatch = true;
					}
				});
				if (hasmatch) {
					return batch;
				}
			});
		}else{
			this.historymatches = [];
		}

		this.setPagination(this.batchHistoryFiltered);
		
	}


	showprints(batch){
		batch.showPrints = batch.showPrints ? false: true;
	}

	sendPrint(data: [], type){
		const user = this.user.user.userid;
		const printers = this.usersService.getDevicesByType(user, type);
		if (printers && printers.length && data.length) {
			this.omsService.setNewOrder();
			data.forEach(doc => {
				const data = { pdf: doc, user: user, devices: printers }	
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			});
		}
	}

	reprint(batch, invoices = 0) {
		batch.printing = true;
		let type = 'BILL OF LADING';
		if (invoices) {
			type = 'INVOICES';
		}
		this.ordersService.reprintStickerBatch(batch.batchid, invoices).subscribe((res: any) => {
			batch.printing = false;
			if(res?.prints?.base64){
				this.globalSearchService.showNotification(`Printing Batch #${batch.batchid} ${type}`, 'success', 'top', 'right');
				this.sendPrint(res.prints.base64, 'INVOICE');
			}else{
				this.globalSearchService.showNotification(`Error printing Batch #${batch.batchid} ${type}`, 'danger', 'top', 'right');
			}
		})
	}

	viewbol(batch) {
		this.batchViewing = batch;
		batch.loading = true;
		this.ordersService.reprintStickerBatch(batch.batchid, 0).subscribe((res: any) => {
			batch.loading = false;
			this.BOLhtml = this.sanitizer.bypassSecurityTrustHtml(atob(res?.prints?.html));
			this.modalService.open(this.reprintModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'bol' }).result.then((result) => {
				this.batchViewing = false;
				this.BOLhtml = false;
			});
		})
	}


	dataObs: Observable<any>;
	items_per_page = [10, 25, 50, 100];
	pagesizedefault = 10;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		this.dataSource.paginator = this.paginator;
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource<any>(tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}


	showauth(ord){
		if(ord.preauthstatus != ''){
			// add tooltip data?
			ord.auth = ord.preauthstatus;
		}
	}

}
